module.exports = __webpack_public_path__ + "static/media/poster-orthodox.9d146be4.jpg";